import script from "./FlowchartEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlowchartEditorDialog.vue?vue&type=script&setup=true&lang=ts"

import "./FlowchartEditorDialog.vue?vue&type=style&index=0&id=3cdf45b5&lang=css"

const __exports__ = script;

export default __exports__